// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_bQO","cls2":"CitingSourcesCard-cls2_DX2 CitingSourcesCard-cls1_bQO"};